import { Grid2, Stack, Typography } from "@mui/material";
import { IconEye } from "@tabler/icons-react";

const Info = ({ title = "", subTitle = "", size = 6, onClick }: any) => (
  <Grid2 size={size}>
    <Typography fontSize={14} color="secondary.contrastText">
      {title}
    </Typography>
    <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
      <Typography fontWeight={700}>{subTitle}</Typography>
      {onClick && <IconEye onClick={onClick} style={{ cursor: "pointer" }} />}
    </Stack>
  </Grid2>
);

export default Info;
